export const LOGGER = 'OBS::LOGGER';
